<template>
    <div>
        <div class="text-14 font-normal text-black mb-2.5" v-if="!hideLabel">
            {{ inputLbl.name }}
        </div>
        <div class="relative pb-5" ref="dropdown-btn" v-click-away="closeDropdown">
            <!-- Dropdown btn -->
            <button class="w-full bg-white pl-4 pr-3 py-1 text-14 font-normal rounded-full h-10 border text-left"
                :class="[isError ? 'border-a-red-ff0000' : isDisable ? 'border-a-gray-a8a8a8 bg-a-gray-e5e5e5' : 'border-a-gray-a8a8a8']" @click="toggleDropdown()">
                <div class="flex items-center justify-between">
                    <div>
                        <span v-if="itemSelected == null" class="font-normal"
                            :class="[isError ? 'text-a-red-ff0000' : 'text-a-gray-a8a8a8']">
                            {{ inputLbl.placeholder  }}
                        </span>
                        <span class="text-black" v-else>{{ itemSelected.text }}</span>
                    </div>
                    <div>
                        <img src="@/assets/icon/ic-chevron-down.svg" alt="" class="transform transition-all rotate-0 w-3 h-3"
                            :class="{ 'rotate-180': showList && itemList.length > 0 }" />
                    </div>
                </div>
            </button>
            <!-- item list -->
            <div v-show="showList && itemList.length > 0" ref="ddl-list-area"
                class="absolute left-0 w-full bg-white rounded-20 overflow-hidden z-index-dropdown shadow-2xl"
                :class="[isBottomDropdown ? 'top-12' : 'bottom-16']">
                <div class="max-h-64 overflow-y-auto flex flex-col min-w-0 gap-4 py-4">
                    <div v-for="(v) in itemList" :key="v.value"
                        class="px-4 cursor-pointer hover:bg-gray-50 text-left text-14 text-black"
                        @click="selectItem(v)">
                        {{ v.text }}
                    </div>
                </div>
            </div>
            <!-- error msg -->
            <div class="text-a-red-ff0000 absolute bottom-0 left-0 w-full text-12 font-normal text-right" v-if="isError">
                {{ getErrorMsg }}
            </div>
        </div>
    </div>
</template>
<script>


/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Array} itemList (required) list of dropdown item { key: '', value: '' }
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputDropdown",
    props: {
        // v-model
        inputValue: { type: [String, Number] },
        itemList: { type: Array, required: true },
        // props
        errorInfo: { type: Object, required: true },
        isShowError: { type: Boolean, default: false },
        isSubmitted: { type: Boolean, default: false },
        // text
        inputLbl: { type: Object, required: true },
        showErrorOnPlaceholder: { type: Boolean, default: false },
        hideLabel: { type: Boolean },
        isDisable: {type: Boolean, default: false}

    },
    data: function () {
        return {
            content: this.inputValue,
            showList: false,
            itemSelected: null,
            errorRequired: false,
            isBottomDropdown: true,
        };
    },
    computed: {
        isError: function () {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function () {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    watch: {
        itemList: function (val) {
            if (val.length > 0) {
                this.setSelectedDropdown();
                this.validateInput();
            }
        }
    },
    mounted: function () {
        this.setSelectedDropdown();
        this.validateInput();
    },
    methods: {
        setSelectedDropdown: function () {
            let item = this.itemList.find((obj) => {
                return obj.value == this.content;
            });
            if (item != null) {
                this.itemSelected = item;
            }
        },

        toggleDropdown: function () {
            if (this.isDisable) return
            if (this.showList) {
                this.closeDropdown();
            } else {
                this.openDropdown();
            }
        },
        openDropdown: function () {
            this.isBottomDropdown = true;
            this.showList = true;

            this.$nextTick(() => {
                let elem = this.$refs['ddl-list-area'];
                let bottom = elem.getBoundingClientRect().bottom;
                let windowHeight = window.innerHeight;

                this.isBottomDropdown = bottom < windowHeight;
            });
        },
        closeDropdown: function () {
            this.showList = false;
        },

        selectItem: function (item) {
            this.content = item.value;
            this.itemSelected = item;
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },

        clearSelect: function () {
            this.content = "";
            this.itemSelected = null;
            this.closeDropdown();

            this.validateInput();
            this.$emit('update:inputValue', this.content);
        },

        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            this.errorRequired = false
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && this.itemSelected == null) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                this.errorRequired = true
                return;
            }
        },
        setValue: function (value) {
            this.content = value;
            this.setSelectedDropdown();
            this.validateInput();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
</style>
